import React, { Component } from 'react';
import { Popconfirm,Table } from 'antd';

class WorkHistory extends Component {
    getList = (isChinese) => {
        const { data, canEdit,crcUsedToBePm } = this.props;
        return (
            data ?
                data.map(item => {
                    const {
                        workStartTime,
                        workEndTime,
                        workCompany,
                        workCompanyEnglish,
                        workDutyChinese,
                        workDutyEnglish,
                        positionChineseName,
                        positionEnglishName,
                        vitaeWorkExperienceId,
                        experienceInvs,
                    } = item;
                    const columns = [{
                        title: isChinese?'临床项目':'Clinical projects',
                        dataIndex:'investigationName',
                        key: 'investigationName',
                        fixed: 'left',
                        width: 500,
                    }, {
                        title: isChinese?'项目领域':'Therapeutic Area',
                        dataIndex:isChinese?'investigationAreaName':'investigationAreaEnglishName',
                        key: isChinese?'investigationAreaName':'investigationAreaEnglishName',
                        fixed: 'left',
                        width: 150,
                    }, {
                        title: isChinese?'参与时间':'Time',
                        dataIndex: 'participationTime',
                        key: 'participationTime',
                        fixed: 'left',
                        width: 250,
                    }];
                    return (
                        <div className="workHistory" key={vitaeWorkExperienceId}>
                            {
                                canEdit &&
                                <div className="operate">
                                    <div className="operate-right">
                                        <Popconfirm title="确定要删除吗?" onConfirm={() => this.props.delete(vitaeWorkExperienceId)}>
                                            <a>删除</a>
                                        </Popconfirm>
                                    </div>
                                </div>
                            }
                            <div className="head">
                                <div className="head-left need-bold ellipsis">{workStartTime.slice(0, 7)}~{workEndTime ? workEndTime.slice(0, 7) : isChinese ? '至今' : 'Present'}</div>
                                <div className="head-middle need-bold ellipsis" title={isChinese ? workCompany : workCompanyEnglish}>{isChinese ? workCompany : workCompanyEnglish}</div>
                                {
                                    crcUsedToBePm?
                                    <div className="head-right need-bold ellipsis" title={isChinese ? `项目职务：${positionChineseName}` : `Role${positionEnglishName}`}>{isChinese ? `项目职务：${positionChineseName}` : `Role${positionEnglishName}`}</div>:
                                    <div className="head-right need-bold ellipsis" title={isChinese ? `职务：${positionChineseName}` : `Position：${positionEnglishName}`}>{isChinese ? `职务：${positionChineseName}` : `Position：${positionEnglishName}`}</div>
                                }
                                
                            </div>
                            <div className="content">
                                {
                                    crcUsedToBePm && 
                                    <div>
                                        <div style={{padding:'10px 0',fontWeight:'700'}}>{isChinese ? "担任项目PM的临床项目经验" : "Clinical project experience as project PM"}</div>
                                        <Table dataSource={experienceInvs} columns={columns}/>
                                    </div>
                                }
                                <div className="content-head need-bold">{isChinese ? "工作职责" : "Responsibility"}：</div>
                                <pre className="content-text">
                                    {isChinese ? workDutyChinese : workDutyEnglish}
                                </pre>
                            </div>
                        </div>
                    )
                })
            :
                null
        )
    }

    render() {
        const { isChinese } = this.props;
        return (
            <div>
                { this.getList(isChinese) }
            </div>
        );
    }
}

export default WorkHistory;


// WEBPACK FOOTER //
// ./src/components/common/generateCurriculumVitae/WorkHistory.js